import FallbackLoader from 'components/FallbackLoader';
import Layout from 'components/Layout';
import { FC, ReactNode, Suspense } from 'react';

import styles from './RouteContainer.module.scss';

export interface Props {
  children: ReactNode;
  isMobile?: boolean;
  withMobileWellSelect?: boolean;
}

const RouteContainer: FC<Props> = ({ children, isMobile, withMobileWellSelect }) => (
  <Layout isMobile={isMobile} withMobileWellSelect={withMobileWellSelect}>
    {/* INFO: The main tag is used in a query selector in useScrollToTop hook */}
    <main className={styles.container}>
      <Suspense fallback={<FallbackLoader />}>{children}</Suspense>
    </main>
  </Layout>
);

export default RouteContainer;
